import * as React from 'react';
import type { SVGProps } from 'react';
const SvgUploadCloud = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="15 30 138 70"
    {...props}
  >
    <g filter="url(#UploadCloud_svg__a)">
      <path
        fill="#fff"
        fillRule="evenodd"
        d="m122.065 62.215-.003-.007c-.407-11.349-9.101-19.828-19.44-21.051-5.171-.612-10.438-2.537-14.636-5.618-12.234-8.978-30.426-4.106-36.25 9.938-1.992 4.805-5.507 9.13-9.627 12.305-14.94 11.514-8.587 39.486 13.719 39.486h60.309c20.358 0 24.741-28.865 5.931-35.05z"
        clipRule="evenodd"
      />
    </g>
    <path
      fill="#427FF8"
      d="M85.534 57.615a2.126 2.126 0 0 0-2.991 0l-7.267 7.987a.942.942 0 0 0 .61 1.606h3.333a.643.643 0 0 1 .654.642v9.167c0 1.095.888 1.983 1.983 1.983h4.276a1.98 1.98 0 0 0 2.027-1.961v-9.166a.643.643 0 0 1 .653-.643h3.38a.942.942 0 0 0 .653-1.606z"
    />
    <defs>
      <filter
        id="UploadCloud_svg__a"
        width={168.043}
        height={134.268}
        x={0}
        y={0}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={3} />
        <feGaussianBlur stdDeviation={17} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.0313726 0 0 0 0 0.054902 0 0 0 0 0.247059 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1119_203646"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1119_203646"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export default SvgUploadCloud;
